import { useMutation } from 'react-query';

import { revokeCertificateConsent } from '../../services/api';
import { queryClient, queryKeys } from '../../utils/react-query';

export const useRevokeCertificateConsent = (registrationId: string) => {
  const { mutate, mutateAsync, isLoading } = useMutation(revokeCertificateConsent, {
    onSuccess: () => queryClient.invalidateQueries([queryKeys.energyAnalysis, registrationId])
  });

  return { revokeCertificateConsent: mutate, revokeCertificateConsentAsync: mutateAsync, isLoading };
};
